import React from "react";
import nodata from "../../assets/nodata-new.svg";
import "./NoData.css";

const NoData = ({ main, containerClsNames }) => {
  return (
    <div className={`nodata ${containerClsNames}`}>
      <img src={nodata} alt="no data" />
      <div className="heading-4">No {main} Data Available</div>
    </div>
  );
};

export default NoData;
